import alt from '../../alt';
import si from 'si';

class OrderHistoryActions {
	constructor() {

	}
	
	getOrderList(){
		if(readCookie('isGuestCheckout') !== "true") {
			si.getOrderHistory().then(this.orderListSuccess, this.orderListFailure);
		}
		return true;
	}
	
	orderListSuccess(data) {
		return data
	}
	
	orderListFailure(data) {
		return data
	}
	
	getOrderDetail(OrderID){
		si.getOrderDetail(OrderID).then(this.orderDetailSuccess, this.orderDetailFailure);
		return true;
	}
	
	orderDetailSuccess(data) {
		return data
	}
	
	orderDetailFailure(data) {
		return data
	}
	
	switchComponent(name) {
		return name;
	}
}

export default alt.createActions(OrderHistoryActions);


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/OrderHistory/OrderHistoryActions.js